import { render, staticRenderFns } from "./input-seat.vue?vue&type=template&id=378a8eea&"
import script from "./input-seat.vue?vue&type=script&lang=js&"
export * from "./input-seat.vue?vue&type=script&lang=js&"
import style0 from "./input-seat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports